import React from 'react';
import PropTypes from 'prop-types';
import ImageUploader from './Image';
import FilesUploader from './Files';

const FileUploader = ({ type, autoUpload, ...props }) => {
  let uploader = null;

  if (type === 'image') {
    uploader = <ImageUploader autoUpload={autoUpload} {...props} />;
  } else {
    uploader = <FilesUploader autoUpload={autoUpload} type={type} {...props} />;
  }
  return uploader;
};

FileUploader.propTypes = {
  autoUpload: PropTypes.bool,
};

FileUploader.defaultProps = {
  autoUpload: false,
};

export default FileUploader;
